export default __webpack_public_path__ + "static/media/MP0066.ee344d72.jpg";